// extracted by mini-css-extract-plugin
export default {"jobsWrapper":"Jobs_jobsWrapper__9DriD"};